import {useSelector} from 'react-redux';

import {getSuccessPageItems} from 'desktop/pages/success/store/selectors/orderItems/orderItems';
import {useGetLocation, DEFAULT_COUNTRY} from 'hooks/location/location';
import {RegionsItemType} from 'hostApplicationStoreType';
import {DoctorDetailsItemType} from 'types/successPage';

/**
 * hook for getting doctor details from first item
 */
export const useGetDoctorDetailsFromTheFirstItem = (): {
    patientName?: string;
    name?: string;
    organizationName?: string;
    city?: string;
    regionCode?: string | null;
} => {
    const items = useSelector(getSuccessPageItems);
    const {regions} = useGetLocation(DEFAULT_COUNTRY);
    const statesUSA = regions ? regions[DEFAULT_COUNTRY] : [];

    const item = items.find(({doctorDetails}) => doctorDetails) as DoctorDetailsItemType;
    if (!item) return {};

    const result = {
        city: item.doctorDetails.city,
        name: item.doctorDetails.name.trim(),
        organizationName: item.doctorDetails.organizationName,
        patientName: item.doctorDetails.patientName,
        regionCode: item.doctorDetails.regionCode,
    };

    const stateName = statesUSA
        ? (statesUSA as RegionsItemType[]).find(({value}) => value === result.regionCode)
        : null;

    return {...result, regionCode: stateName?.label || null};
};
